import { render, staticRenderFns } from "./RedefinirSenhaLogin.vue?vue&type=template&id=bc6e3ab8&"
import script from "./RedefinirSenhaLogin.vue?vue&type=script&lang=js&"
export * from "./RedefinirSenhaLogin.vue?vue&type=script&lang=js&"
import style0 from "./RedefinirSenhaLogin.vue?vue&type=style&index=0&id=bc6e3ab8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports